import { render, staticRenderFns } from "./project-one.vue?vue&type=template&id=1a19fc1c&scoped=true&"
import script from "./project-one.vue?vue&type=script&lang=js&"
export * from "./project-one.vue?vue&type=script&lang=js&"
import style0 from "./project-one.vue?vue&type=style&index=0&id=1a19fc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a19fc1c",
  null
  
)

export default component.exports